import { getFunctions, httpsCallable } from "firebase/functions";
import app from "../firebaseConfig";
import { ApiResponse } from "../Types/Common.type";
import { Summary } from "../Types/Summary";

export interface GetDashboardDataResponse {
  historicSummary: Summary;
  currentMonthSummaries: Summary[];
  currentDate: string;
}

export interface ChartDataPoint {
  day: string;
  sales: number;
}

export const getDashboardData = async (): Promise<GetDashboardDataResponse> => {
  try {
    const functions = getFunctions(app);
    const getDashboardDataFunction = httpsCallable<{}, ApiResponse>(
      functions,
      "getDashboardData"
    );

    const result = (await getDashboardDataFunction({})).data;

    if (result.code === 200) {
      return (
        result.data || {
          historicSummary: null,
          currentMonthSummaries: [],
          currentDate: new Date().toISOString().split("T")[0],
        }
      );
    } else {
      throw new Error(result.message || "Error fetching dashboard data");
    }
  } catch (error) {
    console.error("Error fetching dashboard data:", error);
    throw error;
  }
};

export const formatSummariesForChart = (
  summaries: Summary[]
): ChartDataPoint[] => {
  // Sort summaries by date
  const sortedSummaries = summaries.sort((a, b) =>
    a.date.localeCompare(b.date)
  );

  return sortedSummaries.map((summary) => ({
    day: summary.date.split("-")[2], // Extract day from YYYY-MM-DD
    sales: summary.sales_amount,
  }));
};

export const calculateTotalSales = (summaries: Summary[]): number => {
  return summaries.reduce((total, summary) => total + summary.sales_amount, 0);
};
